import { API_BASE } from '../../config';
import { getJwt } from '../../traccar';

const request = async (path, body = {}) => {
  const token = getJwt();
  const response = await fetch(`${API_BASE}/ringcentral/phone/conference${path}`, { method: 'POST', signal: AbortSignal.timeout(25000), credentials: 'include', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: JSON.stringify(body) });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || 'Could not connect the conference.');
  return data;
};
export const createConference = () => request('');
export const bringIntoConference = (host, guest) => request('/merge', { conferenceId: host.sessionId, conferencePartyId: host.partyId, sessionId: guest.sessionId, partyId: guest.partyId });
